import gql from 'graphql-tag';

import type { UpdatePreferenceRequest } from '@coursera/grpc-types-notifications/coursera/proto/notifications/preference/v1/notification_preference_api';

export type UpdateNotificationPreferencesMutationVariables = {
  input: UpdatePreferenceRequest;
};

export const UpdateNotificationPreferencesMutation = gql`
  mutation UpdateNotificationPreferencesMutation($input: UpdateNotificationPreferencesMutationVariables!) {
    UpdatePreference(input: $input)
      @rest(
        type: "UpdatePreference"
        path: "grpc/notifications/preference/v1/NotificationPreferenceAPI/UpdatePreference"
        method: "POST"
      )
  }
`;
